import React, { useEffect, useRef } from "react";
import SchoolAdminDashboard from "../schoolAdminDashboard";
import Container from "@material-ui/core/Container";
import { useParams } from "react-router-dom";
import { FormGroup } from "reactstrap";
import { getFromLocalStorage } from "../../../utils/webStorage";
import { formatPhoneNumber, formatContactNumber } from "../../../utils";
import { Field, Form, Formik } from "formik";
import validationSchema from "../../../Validation/ValidationSchemas";
import { unFormatPhoneNumber } from "../../../Common/unFormatPhoneNumber";
import { useDispatch, useSelector } from "react-redux";
import CamelCaseString from "../../../Common/CamelCaseString";
import { openConfirmationPopup } from "../../../Redux/Actions/PopupActions";
import PageNotFoundPage from "../../../Common/PageNotFoundPage";
import CustomDropDown from "../../../Common/FormFields/CustomDropDown";
import CustomMultiSelectDropdown from "../../../Common/FormFields/CustomMultiSelectDropdown";
import FormikTextField from "../../../Common/FormFields/FormikInputField";

import {
  getAllGroupList,
  resetGroupData,
  searchGroup,
  setGroupSearchQuery,
  setGroupSearchedRecord,
  setSelectedGroupsList,
} from "../../../Redux/Actions/GroupActions";
import { ContentLayoutSpinner } from "../../spinner/ContentLayoutSpinner";
import ContentLayoutHeader from "../../../Common/ContentLayoutHeader";
import ImageUploadContainer from "../../../Common/FormFields/ImageUploadContainer";
import {
  addAthlete,
  editAthlete,
  getAthleteData,
  handleAthleteLogoUpload,
  resetAthleteData,
  setAthleteGraduationYear,
} from "../../../Redux/Actions/AthleteActions";

const AddEditAthlete = () => {
  const schoolId = getFromLocalStorage("schoolId");
  const currentUserId = getFromLocalStorage("currentUserId");
  const adminRole = getFromLocalStorage("loginRole");
  const { athleteId } = useParams();
  const dispatch = useDispatch();
  const myref = useRef();
  const scrollRef = useRef();
  const loading = useSelector((state) => state?.AthleteData?.loading);
  const currentSeason = useSelector(
    (state) => state.loggedInUser.userProfile.currentSeason
  );
  const athleteData = useSelector((state) => state?.AthleteData);

  const groupPageState = useSelector(
    (state) => state?.GroupsData?.groupPageState
  );
  const groupList = useSelector((state) => state?.GroupsData?.groupList);
  const selectedGroupList = useSelector(
    (state) => state?.GroupsData?.selectedGroupList
  );
  const scrollLoading = useSelector(
    (state) => state?.GroupsData?.loading?.scrollLoading
  );
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );
  const assignedRights = JSON.parse(
    getFromLocalStorage("assignedRights") || []
  ).map((item) => item.displayName);

  useEffect(() => {
    athleteId && getAthleteData(dispatch, { id: athleteId });
    getAllGroupList(dispatch, {
      schoolId,
      page: groupPageState?.page,
      size: groupPageState?.size,
    });

    return () => {
      resetAthleteData(dispatch);
      resetGroupData(dispatch);
    };
  }, []);

  const handleSubmit = ({
    firstName,
    lastName,
    email,
    phoneNumber,
    positionPlayed,
    jerseyNumber,
    groupIds,
    graduationYear,
    instaUrl,
    twitterUrl,
  }) => {
    if (!athleteId) {
      addAthlete(dispatch, {
        firstName: CamelCaseString(firstName),
        lastName: CamelCaseString(lastName),
        email,
        phoneNumber: unFormatPhoneNumber(phoneNumber),
        jerseyNumber,
        positionPlayed: CamelCaseString(positionPlayed),
        group: "",
        profileImageId: athleteData?.athleteLogoId,
        graduationYear,
        schoolId,
        groupIds: selectedGroupList.map((item) => item.id),
        teamIds: [],
        instaUrl,
        twitterUrl,
        sportsIds: [],
        currentUserId,
      });
    } else {
      editAthlete(dispatch, {
        firstName: CamelCaseString(firstName),
        lastName: CamelCaseString(lastName),
        email,
        phoneNumber: unFormatPhoneNumber(phoneNumber),
        positionPlayed: CamelCaseString(positionPlayed),
        graduationYear,
        profileImageId: athleteData?.athleteLogoId,
        id: athleteId,
        jerseyNumber,
        schoolId,
        groupIds: selectedGroupList.map((item) => item.id),
        instaUrl,
        twitterUrl,
      });
    }
  };

  const handleGroups = (value, isAdded) => {
    setSelectedGroupsList(dispatch, {
      selectedList: isAdded
        ? [...selectedGroupList, value]
        : selectedGroupList?.filter((el) => el.id !== value.id),
    });
  };

  const setSearchQueryOrSearchedRecord = (
    value,
    pageStateName,
    isSearchQuery
  ) => {
    if (isSearchQuery) {
      setGroupSearchQuery(dispatch, {
        pageStateName: pageStateName,
        searchQuery: value,
      });
    } else {
      setGroupSearchedRecord(dispatch, {
        pageStateName: pageStateName,
        status: value,
      });
    }
  };

  const onScrollGroupList = () => {
    if (groupPageState?.page < groupPageState?.totalPages && !scrollLoading) {
      if (scrollRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
        if (Math.round(scrollTop + clientHeight + 1) >= scrollHeight) {
          groupPageState?.searchedRecord
            ? searchGroup(dispatch, {
                searchQuery: groupPageState?.searchQuery,
                schoolId,
                page: groupPageState?.page,
                size: groupPageState?.pageSize,
              })
            : getAllGroupList(dispatch, {
                schoolId,
                page: groupPageState?.page,
                size: groupPageState?.pageSize,
              });
        }
      }
    }
  };

  const getDefaulData = (page) => {
    getAllGroupList(dispatch, {
      schoolId,
      page: page,
      size: 10,
    });
  };

  const handleGroupSearch = (value, page, size) => {
    searchGroup(dispatch, {
      searchQuery: value,
      schoolId,
      page: page,
      size: size,
    });
  };

  const checkSelectedGroups = () => {
    const filteredGroupList = groupList?.map((ol) => {
      const isSelected = selectedGroupList?.filter((el) => el.id === ol.id);
      return isSelected?.length > 0
        ? { ...ol, disabled: true }
        : { ...ol, disabled: false };
    });

    return filteredGroupList;
  };

  const setSearchQuery = (value) => {
    setSearchQueryOrSearchedRecord(value, "groupPageState", true);
  };

  const setSearchedRecord = (value) => {
    setSearchQueryOrSearchedRecord(value, "groupPageState", false);
  };

  const handleCancel = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: "Are You Sure, You Want To Cancel?",
        btnColor: "red",
        btnText: "Yes",
        id: athleteId,
        type: "Add / Edit Athlete",
      },
    });
  };

  const getYearList = () => {
    let yearList = [];
    const date = new Date();
    let currentYear = date.getFullYear();
    for (let index = 1; index <= 10; index++) {
      yearList.push({ label: currentYear++ });
    }
    return yearList;
  };

  return (
    <Formik
      innerRef={myref}
      initialValues={{
        firstName: !athleteId ? "" : athleteData?.athleteData?.firstName,
        lastName: !athleteId ? "" : athleteData?.athleteData?.lastName,
        email: !athleteId ? "" : athleteData?.athleteData?.email,
        phoneNumber: !athleteId
          ? ""
          : formatPhoneNumber(athleteData?.athleteData?.phoneNumber),
        positionPlayed: !athleteId
          ? ""
          : athleteData?.athleteData?.positionPlayed,
        jerseyNumber: !athleteId ? "" : athleteData?.athleteData?.jerseyNumber,
        graduationYear: !athleteId
          ? ""
          : athleteData?.athleteData?.graduationYear,
        groupIds: [],
        instaUrl: !athleteId ? "" : athleteData?.athleteData?.instagramLink,
        twitterUrl: !athleteId ? "" : athleteData?.athleteData?.twitterLink,
      }}
      enableReinitialize
      validationSchema={validationSchema.athleteFormValidation}
      onSubmit={(values) => handleSubmit(values)}
    >
      {(formik) => (
        <Form>
          <div>
            {(adminRole == "SCHOOL ADMIN" ||
              assignedRights.includes("Add / Remove Athletes")) &&
            currentSeason ? (
              <div
                //className="content-layout add-sectionn p-0 position-relative"
                className={
                  isDrawerOpen
                    ? "content-layout add-sectionn p-0 position-relative"
                    : "toggle-content-layout add-sectionn p-0 position-relative"
                }
              >
                <SchoolAdminDashboard />
                <ContentLayoutSpinner animate={loading?.pageLoading} />
                <ContentLayoutHeader
                  heading={
                    athleteId
                      ? `Edit : ${
                          athleteData?.athleteData?.firstName ||
                          athleteData?.athleteData?.lastName
                            ? `${athleteData?.athleteData?.firstName || ""} ${
                                athleteData?.athleteData?.lastName || ""
                              }`
                            : "Athlete"
                        }`
                      : "Add Athlete"
                  }
                  handleCancel={handleCancel}
                  navigationLink={
                    athleteId
                      ? `/athletedetails/${athleteId}`
                      : "/schoolathletes"
                  }
                  btnText={athleteId ? "Save" : "Add"}
                  loading={loading?.buttonLoading}
                  disabled={!formik.isValid}
                />

                <Container className="mg-top-70">
                  <form name="adminRegistrationForm" className="moboMargin-5">
                    <div className="row">
                      <div className="col-12 col-lg-5 col-md-10">
                        <div className="white-card2 ">
                          <ImageUploadContainer
                            id="upload-photo-1"
                            logoUrl={athleteData?.athleteLogo}
                            handleUpload={(file) =>
                              handleAthleteLogoUpload(dispatch, {
                                file: file,
                                currentUserId: currentUserId,
                              })
                            }
                            label={
                              athleteData?.athleteLogo
                                ? "Update Profile Photo"
                                : "Add Profile Photo"
                            }
                            loading={loading?.profileImageLoading}
                          />
                        </div>
                        <div className="clear20"></div>
                        <div className="white-card2 ">
                          <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <FormikTextField
                                label="First Name"
                                formik={formik}
                                fieldName="firstName"
                                placeholder="Enter First name"
                                labelFontSize="fs-18"
                              />
                              <FormikTextField
                                label="Last Name"
                                formik={formik}
                                fieldName="lastName"
                                placeholder="Enter Last name"
                                labelFontSize="fs-18"
                              />
                              <FormikTextField
                                label="Email"
                                formik={formik}
                                fieldName="email"
                                placeholder="Enter Email Address"
                                labelFontSize="fs-18"
                                isDisabled={!athleteId ? false : true}
                              />
                              <FormikTextField
                                label="Phone Number"
                                formik={formik}
                                fieldName="phoneNumber"
                                placeholder="Enter Phone Number"
                                labelFontSize="fs-18"
                                onKeyUp={(e) =>
                                  formatContactNumber(e.target.value, myref)
                                }
                                maxLength={14}
                              />
                              <FormGroup>
                                <label className="fmlabel mt-6 semi-bold fs-18">
                                  Graduation Year{" "}
                                  <span className="redstar">*</span>
                                </label>
                                <CustomDropDown
                                  selected={
                                    athleteData?.athleteData?.graduationYear
                                  }
                                  setSelected={(value) =>
                                    setAthleteGraduationYear(dispatch, value)
                                  }
                                  formik={formik}
                                  fieldName="graduationYear"
                                  defaultSelectOption="Select Graduation Year"
                                  options={getYearList()}
                                  fieldToShow="label"
                                  optionValue="label"
                                />
                              </FormGroup>
                              <FormikTextField
                                label="Position Played"
                                formik={formik}
                                fieldName="positionPlayed"
                                placeholder="Enter Position Played"
                                labelFontSize="fs-18"
                              />
                              <FormikTextField
                                label="Jersey Number"
                                formik={formik}
                                fieldName="jerseyNumber"
                                placeholder="Enter Jersey Number"
                                labelFontSize="fs-18"
                              />
                              <FormGroup className="fs-14">
                                <label className="fmlabel mt-6 semi-bold fs-18">
                                  Groups <span className="redstar"></span>
                                </label>
                                <CustomMultiSelectDropdown
                                  defaultSelectOption="Select Groups"
                                  selected={selectedGroupList}
                                  setSelected={handleGroups}
                                  options={checkSelectedGroups()}
                                  fieldToShow="groupName"
                                  isDisabled="disabled"
                                  searchQuery={groupPageState?.searchQuery}
                                  setSearchQuery={setSearchQuery}
                                  searchedRecord={
                                    groupPageState?.searchedRecord
                                  }
                                  setSearchedRecord={setSearchedRecord}
                                  getDataByPage={getDefaulData}
                                  searchData={handleGroupSearch}
                                  onScroll={onScrollGroupList}
                                  ref={scrollRef}
                                />
                              </FormGroup>
                            </div>
                          </div>
                        </div>
                        <div className="clear20"></div>
                      </div>
                      <div className="col-12 col-lg-6 col-md-10 ">
                        <div className="athlete-bg">
                          <div className="activity-trending-container mg-left-auto pd-15 brd-none">
                            <FormikTextField
                              label="Instagram"
                              formik={formik}
                              fieldName="instaUrl"
                              placeholder="Enter Instagram Account Link"
                              labelFontSize="fs-18"
                              notRequired={true}
                            />
                            <FormikTextField
                              label="Twitter"
                              formik={formik}
                              fieldName="twitterUrl"
                              placeholder="Enter Twitter Account Link"
                              labelFontSize="fs-18"
                              notRequired={true}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </Container>
              </div>
            ) : (
              <PageNotFoundPage />
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default AddEditAthlete;
